import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';

import { PROFILE_FIELDS_TYPES } from '../../../../constants/formFields';
import { FormErrorBlock } from '../../../common/FormErrorBlock';
import PasswordInput from '../../../TextInput/PasswordInput';
import DateDropdown from '../../../common/DateDropdown';
import SelectCustom from '../../../SelectCustom';
import { SSNField } from '../../../SSNField';
import TextInput from '../../../TextInput';
import {
  FIELD_FILLING_TYPES,
  getFieldProps,
} from '../../../../utils/fields/getFieldProps';
import { selectSsnHidingEnabled } from '../../../../redux/data/selectors';

const {
  LAST_NAME,
  FIRST_NAME,
  DOB,
  SSN,
  LOCAL_UID,
  NAME_SUFFIX,
} = PROFILE_FIELDS_TYPES;

const PatientInfoForm = ({
  nameSuffixList,
  nameSuffix,
  validateErrors,
  formatMessage,
  firstName,
  lastName,
  onChange,
  mrn,
  dob,
  ssn,
}) => {
  const makeProfileField = getFieldProps(formatMessage, onChange);

  const ssnHidingEnabled = useSelector(selectSsnHidingEnabled);

  return (
    <Fragment>
      {/*     F I R S T   N A M E     */}
      <TextInput {...makeProfileField(FIRST_NAME)} value={firstName} />
      <FormErrorBlock type={FIRST_NAME} errors={validateErrors} />
      {/*     L A S T   N A M E     */}
      <TextInput {...makeProfileField(LAST_NAME)} value={lastName} />
      <FormErrorBlock type={LAST_NAME} errors={validateErrors} />
      {/*     N A M E   S U F F I X     */}
      <SelectCustom
        {...makeProfileField(NAME_SUFFIX)}
        options={nameSuffixList}
        value={nameSuffix}
        needUpdateDefaultValue
      />
      {/*     D O B     */}
      <DateDropdown {...makeProfileField(DOB)} value={dob} />
      {/*     M R N S     */}
      <TextInput
        {...makeProfileField(LOCAL_UID, FIELD_FILLING_TYPES.OPTIONAL)}
        value={mrn}
      />
      <FormErrorBlock type={LOCAL_UID} errors={validateErrors} />
      {/*     S S N     */}
      {!ssnHidingEnabled && (
        <SSNField
          formatMessage={formatMessage}
          noMarginBottom
          children={
            <PasswordInput
              {...makeProfileField(SSN, FIELD_FILLING_TYPES.OPTIONAL)}
              value={ssn}
            />
          }
        />
      )}
      <FormErrorBlock type={SSN} errors={validateErrors} />
    </Fragment>
  );
};

PatientInfoForm.propTypes = {
  validateErrors: PropTypes.oneOfType([
    PropTypes.bool,
    PropTypes.shape({ description: PropTypes.string }),
  ]),
  nameSuffixList: PropTypes.array,
  nameSuffix: PropTypes.string,
  ssn: PropTypes.string,
  formatMessage: PropTypes.func,
  firstName: PropTypes.string,
  lastName: PropTypes.string,
  onChange: PropTypes.func,
  mrn: PropTypes.string,
  dob: PropTypes.string,
};

export default PatientInfoForm;



// WEBPACK FOOTER //
// ./src/components/PatientRegistration/PatientRegistrationInfo/PatientInfoForm/index.jsx